import {AxiosError} from 'axios';
import {GLOBAL_REQUEST_ERROR_MESSAGE} from '../../../constants';

const errorResponseManager = ({
  response,
}: AxiosError): {msg: string; status: number; data?: any} => {
  const {data = {}, status = 0} = response || {};

  const messages: Record<number, string> = {
    0: 'Sunucuya bağlanılamadı. İnternet bağlantınızı kontrol edip tekrar deneyin.',
    400: 'Bilgiler kaydedilemedi. Girdiğiniz alanları kontrol edin.',
    401: 'Oturumunuz sona ermiş olabilir. Lütfen yeniden giriş yapın.',
    403: 'Bu işlem için yetkiniz bulunmuyor.',
    404: 'İstenen kayıt bulunamadı. Sayfayı yenileyip tekrar deneyin.',
    409: 'Bu işlem mevcut bir kayıtla çakışıyor. Bilgileri kontrol edin.',
    422: 'Bazı bilgiler eksik veya geçersiz. Lütfen alanları kontrol edin.',
    429: 'Kısa sürede çok fazla işlem yapıldı. Biraz bekleyip tekrar deneyin.',
  };
  const msg = messages[status] || (status >= 500
    ? 'İşlem şu anda tamamlanamıyor. Lütfen biraz sonra tekrar deneyin.'
    : GLOBAL_REQUEST_ERROR_MESSAGE);

  return {msg, data, status};
};

export {errorResponseManager};
